export { default } from '../map/esri/ReactEsriMap';
